var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "游戏", clearable: "", filterable: "" },
                  model: {
                    value: _vm.paramsData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "appid", $$v)
                    },
                    expression: "paramsData.appid"
                  }
                },
                _vm._l(_vm.gameList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.show_name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "服务器", clearable: "" },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                _vm._l(_vm.GamesServersList, function(item, index) {
                  return _c(
                    "el-option",
                    {
                      key: index,
                      attrs: { label: item.show_name, value: item.id }
                    },
                    [
                      _vm._v(
                        _vm._s(item.game_show_name + " - " + item.show_name)
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "网关用户ID" },
                model: {
                  value: _vm.paramsData.gate_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "gate_user_id", $$v)
                  },
                  expression: "paramsData.gate_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "研发订单ID" },
                model: {
                  value: _vm.paramsData.developer_order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "developer_order_id", $$v)
                  },
                  expression: "paramsData.developer_order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "研发商品ID" },
                model: {
                  value: _vm.paramsData.product,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "product", $$v)
                  },
                  expression: "paramsData.product"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "研发用户ID" },
                model: {
                  value: _vm.paramsData.developer_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "developer_user_id", $$v)
                  },
                  expression: "paramsData.developer_user_id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "订单号" },
                model: {
                  value: _vm.paramsData.order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "order_id", $$v)
                  },
                  expression: "paramsData.order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                },
                on: { change: _vm.dateChange },
                model: {
                  value: _vm.value2,
                  callback: function($$v) {
                    _vm.value2 = $$v
                  },
                  expression: "value2"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "支付状态", clearable: "" },
                  model: {
                    value: _vm.paramsData.state,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "state", $$v)
                    },
                    expression: "paramsData.state"
                  }
                },
                _vm._l(_vm.stateList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "topBannerTable",
          attrs: { data: _vm.pagingList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "appid", label: "游戏", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.gameList.findIndex(function(i) {
                            return i.appid == row.appid
                          }) > -1
                            ? _vm.gameList.find(function(i) {
                                return i.appid == row.appid
                              }).show_name
                            : row.appid
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "appid", label: "APPID", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "gate_user_id", label: "网关用户ID", width: "300" }
          }),
          _c("el-table-column", {
            attrs: { prop: "product", label: "研发商品id", width: "120" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "developer_user_id",
              label: "研发用户ID",
              width: "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "developer_order_id",
              label: "研发订单ID",
              width: "340"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "device_id", label: "设备ID", width: "220" }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_id", label: "服务器ID", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "product_name", label: "商品名称", width: "200" }
          }),
          _c("el-table-column", {
            attrs: { prop: "product_desc", label: "商品描述", width: "200" }
          }),
          _c("el-table-column", {
            attrs: { prop: "price", label: "价格(分)", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { prop: "currency", label: "货币类型", width: "140" }
          }),
          _c("el-table-column", {
            attrs: { prop: "ip", label: "IP", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { prop: "order_id", label: "订单号", width: "240" }
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "订单状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(row.state == 1 ? "已支付" : "未支付") + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "创建时间", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$times.formDate(row.created_at)) + " "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.pagingList.length
        ? _c("el-pagination", {
            staticClass: "x-c",
            attrs: {
              layout: "total, prev, pager, next,jumper",
              "current-page": _vm.paramsData.page,
              total: _vm.totalNum,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }